// src/services/socketService.js
import { io } from 'socket.io-client';
import store from '../store/store';
/* Un seul endroit décide de l'environnement. */
const estProduction = process.env.NODE_ENV === 'production';

/**
 * VUE_APP_API_URL_SOCKET vaut "http://localhost:9595/socket.io/".
 * io() interprète le CHEMIN de l'URL comme un NAMESPACE : passée telle quelle,
 * elle connecte au namespace "/socket.io/", qui n'existe pas côté serveur.
 * On sépare donc l'origine (l'hôte) du chemin (option `path`).
 */
const cibleSocket = () => {
    const u = new URL(process.env.VUE_APP_API_URL_SOCKET);
    return { origine: u.origin, chemin: u.pathname || '/socket.io/' };
};


class SocketService {
    constructor() {
        this.socket = null;
        this.onMessageCallback = null;
        this.onPrivateMessageCallback = null;
    }

    /*initializeSocket() {
        if (!this.socket) {
            // this.socket = io(process.env.VUE_APP_API_URL_SOCKET);

            console.log("initializeSocket ********* ")
            console.log("process.env.VUE_APP_API_URL_SOCKET ********* ",process.env.VUE_APP_API_URL_SOCKET)


            this.socket  = io(process.env.VUE_APP_API_URL_SOCKET, {
                 path: "/socket.io/", // Indique le bon chemin
                transports: ['websocket'], // Utilise uniquement WebSocket
                //secure: process.env.VUE_APP_API_URL.startsWith('https'), // Active le mode sécurisé si l'URL commence par 'https'
                reconnectionAttempts: 5, // Nombre de tentatives de reconnexion
                reconnectionDelay: 1000, // Délai entre les tentatives en ms
                rejectUnauthorized: false // Rejet des certificats non autorisés (à éviter en production)
            });

            this.socket.on('connect', () => {
                console.log('Connecté au serveur Socket.IO avec ID :', this.socket.id);

                store.commit('appusersocketid',{name:this.socket.id})
            });



            this.socket.on('disconnect', () => {
                console.log('Socket déconnecté');
            });

            // Gestion des messages publics
            this.socket.on('message', (msg) => {
                console.log('Message reçu:', msg);
                if (this.onMessageCallback) {
                    this.onMessageCallback(msg);
                }
            });

            // Gestion des messages privés
            this.socket.on('privateMessage', (msg) => {
                console.log('Message privé reçu:', msg);
                if (this.onPrivateMessageCallback) {
                    this.onPrivateMessageCallback(msg);
                }
            });
        }
    }*/

initializeSocket() {
    if (this.socket) return;   // garde plate : une indentation de moins sur tout le corps

    const { origine, chemin } = cibleSocket();

    this.socket = io(origine, {
        path: chemin,
        transports: ['websocket'],

        secure: estProduction,
       // rejectUnauthorized: estProduction,

        /* 5 tentatives ne survivent pas au cron_restart de 5 h (voir plus bas). */
        reconnectionAttempts: estProduction ? Infinity : 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
    });

    this.socket.on('connect', () => {
        store.commit('appusersocketid', { name: this.socket.id });
    });

    this.socket.on('message', (msg) => {
        if (this.onMessageCallback) this.onMessageCallback(msg);
    });

    this.socket.on('messageconnecte', (msg) => {
        if (this.onPrivateMessageCallback) this.onPrivateMessageCallback(msg);
    });
}

    onListener(event, callback) {
        if (this.socket) {
            try {
                this.socket.on(event, (data) => {
                    console.log(`Message reçu pour ${event}:`, data); // Log les données pour débogage
                    callback(data); // Appelle la fonction de rappel avec les données reçues
                });
            } catch (error) {
                console.error(`Erreur lors de l'écoute de l'événement ${event}:`, error);
            }
        } else {
            console.error('Socket non initialisé dans onListener');
        }
    }


    emitEvent(event, data) {


        if (this.socket) {
            this.socket.emit(event, data);
        } else {
            console.error('Socket non initialisé emitEvent');
        }


    }

    sendMessage(event, message) {
        if (this.socket) {
            this.socket.emit(event, message);
        } else {
            console.error('Socket non initialisé');
        }
    }


    sendPrivateMessage(event,room, message) {
        if (this.socket) {
            //this.socket.emit('privateMessage', { room, message });
            this.socket.emit(event, { room, message });
        } else {
            console.error('Socket non initialisé');
        }
    }



    onMessage(callback) {
        this.onMessageCallback = callback;
    }

    onPrivateMessage(callback) {
        this.onPrivateMessageCallback = callback;
    }

    joinRoom(event,room) {
        if (this.socket) {
            //this.socket.emit('join_room', room);
            // console.log("event ********** ",event)
            //console.log("room ********** ",room)

            this.socket.emit(event, room);
        } else {
            console.error('Socket non initialisé');
        }
    }

    leaveRoom(event,room) {
        if (this.socket) {
            this.socket.emit(event, room);
        } else {
            console.error('Socket non initialisé');
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export const socketService = new SocketService();
